import React from 'react';
import SelectStepTemplate from '../../../template/SelectStepTemplate';
import useGetMateriais, {
  buildOutrosTecidos,
} from '../../../template/UseGetMateriais';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import { TipoDivergenciaComponent } from '../../../TiposDeDivergencias';
import FaltaDeTecidoQuantidadeStep from './FaltaDeTecidoQuantidadeStep';

const FaltaDeTecidoInterno: TipoDivergenciaComponent = ({ onSetStep, onBack }) => {
  const { loading, materiais } = useGetMateriais(
    TipoDivergenciasInfoKey.TECIDO
  );
  const newMateriais = [...materiais, buildOutrosTecidos()];

  const stepNumber = '2';
  const stepSubTitle = 'Selecione o tecido em falta.';
  const stepTitle = 'Qual tecido está faltando?';
  return (
    <SelectStepTemplate
      data={newMateriais}
      loading={loading}
      nextStepComponent={
        FaltaDeTecidoQuantidadeStep as TipoDivergenciaComponent
      }
      onBack={onBack}
      onSetStep={onSetStep}
      payloadKey='tecidos'
      stepNumber={stepNumber}
      stepSubTitle={stepSubTitle}
      stepTitle={stepTitle}
    />
  );
};

export default FaltaDeTecidoInterno;
